import React, { useCallback, useMemo } from 'react'

import { TabPanel } from '@tabeeb/enums'
import { useDispatch, useSelector } from '@tabeeb/store'
import { ExpandButton, ExpandButtonProps } from '@collaborate-health/uikit'

import { getIsAnyTabExpanded, getIsTabExpanded } from '@tabeeb/modules/sessionTabs/selectors'
import { collapsePanel, expandPanel } from '@tabeeb/modules/sessionTabs/actions'

interface ExpandSessionTabButtonProps {
  panel: TabPanel
  orientation: ExpandButtonProps['orientation']
}

const ExpandSessionTabButton: React.FC<ExpandSessionTabButtonProps> = ({ panel, orientation }) => {
  const dispatch = useDispatch()

  const expanded = useSelector<boolean>((state) => getIsTabExpanded(state, panel))
  const isAnyPanelExpanded = useSelector(getIsAnyTabExpanded)

  const handleExpandClick = useCallback(() => {
    if (expanded) {
      dispatch(collapsePanel(panel))
    } else {
      dispatch(expandPanel(panel))
    }
  }, [dispatch, expanded, panel])

  const isDisabled = useMemo(() => {
    return isAnyPanelExpanded && !expanded
  }, [expanded, isAnyPanelExpanded])

  return (
    <ExpandButton
      expanded={expanded}
      onClick={handleExpandClick}
      buttonProps={{ shape: 'rectangular', disabled: isDisabled }}
      orientation={orientation}
    />
  )
}

export default ExpandSessionTabButton

